import { Popper, PopperProps } from '@mui/material';
import React, { forwardRef } from 'react';

interface SearchSuggestionPopperProps extends PopperProps {
  anchorEl: HTMLElement | null;
}

const SearchSuggestionPopper = forwardRef<HTMLDivElement, SearchSuggestionPopperProps>(
  (props, ref) => {
    const { style, anchorEl, ...rest } = props;
    return (
      <Popper
        anchorEl={anchorEl}
        ref={ref}
        {...rest}
        style={{ ...style, width: anchorEl?.offsetWidth}}
        placement="bottom-start"
      />
    );
  }
);

export default SearchSuggestionPopper;
